




































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';

import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import PrescriptionModel from '@/models/prescription-model';
import * as service from '@/services/prescription';
import * as prescriptionStatus from '@/settings/consts/prescription-status';
import IPrescription from '@/interfaces/prescription';
import { dateFormat } from '@/helpers/dateFormat';
import { combineAll, catchError } from 'rxjs/operators';
import { Observable, combineLatest, empty } from 'rxjs';
import { errorHandling } from '@/helpers/errorHandling';
import { MESSAGE_TRANSCRIPTION_ON_LOAD_ERROR } from '@/settings/consts/messages';

@Component({
  components: {
    PermissionAuth,
  },
})
export default class PrescriptionTranscriptionModalList extends BaseComponent {
  @Prop()
  public data: PrescriptionModel[];

  public headers: any[] = [
    { text: 'Comparar', value: '', sortable: false },
    { text: 'ID', value: 'idPrescricao' },
    { text: 'Responsável', value: 'responsavel.nome' },
    { text: 'Data do agendamento', value: 'dataPrescricaoTime' },
    { text: 'Cliente', value: 'cliente.nome' },
    { text: 'Médico', value: 'medico.nome' },
    { text: 'Paciente', value: 'paciente.nome' },
    {
      text: 'Status',
      value: 'statusPrescricao',
      align: 'center',
      sortable: false,
    },
  ];

  public transcriptions: PrescriptionModel[] = [];

  @Watch('data')
  public onDataChange(val): void {
    this.transcriptions = [];
  }

  public formatDate(date: string): string {
    return dateFormat(date, 'BR', 'YYYY-MM-DD');
  }

  public disableCheckbox(transcription: PrescriptionModel): boolean {
    const itemInTranscriptions = () =>
      this.transcriptions.some(
        (item) => item.idPrescricao === transcription.idPrescricao,
      );
    return this.totalTranscriptionIsValid() && !itemInTranscriptions();
  }

  public totalTranscriptionIsValid(): boolean {
    const totalOfTranscriptions = 2;
    return this.transcriptions.length === totalOfTranscriptions;
  }

  public closeForm(): void {
    this.transcriptions = [];
    this.$emit('close');
  }

  public onCompare(): void {
    this.loader.start();

    const combineGetTrasncriptions = [];
    this.transcriptions.map((transcription) => {
      combineGetTrasncriptions.push(
        service.getPrescription(transcription.idPrescricao),
      );
    });

    const onError = (error) => {
      this.loader.stop();
      const errorMessages = {
        default: MESSAGE_TRANSCRIPTION_ON_LOAD_ERROR,
      };

      const message = errorHandling(error, errorMessages);
      this.toast.show(message, 'error');
    };

    combineLatest(
      combineGetTrasncriptions,
      (
        firstTranscription: IPrescription,
        secondTranscription: IPrescription,
      ) => {
        const transcriptions = [
          new PrescriptionModel(firstTranscription),
          new PrescriptionModel(secondTranscription),
        ];

        return transcriptions;
      },
    )
      .pipe(
        catchError((error) => {
          onError(error);
          return empty();
        }),
      )
      .subscribe((prescriptions) => {
        this.loader.stop();

        if (!!prescriptions.length) {
          this.$emit('selectTranscriptions', prescriptions);
        }
      }, onError);
  }

  public getStatus(item: IPrescription): any {
    let statusObject;

    switch (item.statusPrescricao) {
      case prescriptionStatus.SENT_TO_PRODUCTION.key:
        statusObject = prescriptionStatus.SENT_TO_PRODUCTION;
        break;
      case prescriptionStatus.DENIED.key:
        statusObject = prescriptionStatus.DENIED;
        break;
      case prescriptionStatus.WAITING_PHARMACEUTICAL_APPROVE.key:
        statusObject = prescriptionStatus.WAITING_PHARMACEUTICAL_APPROVE;
        break;
      case prescriptionStatus.WAITING_TRANSCRIPTION.key:
        statusObject = prescriptionStatus.WAITING_TRANSCRIPTION;
        break;
      case prescriptionStatus.CHECKED_TRANSCRIPTION.key:
        statusObject = prescriptionStatus.CHECKED_TRANSCRIPTION;
        break;
      case prescriptionStatus.ERROR_ON_SEND_TO_PRODUCTION.key:
        statusObject = prescriptionStatus.ERROR_ON_SEND_TO_PRODUCTION;
        break;
      default:
        statusObject = {};
    }

    return statusObject;
  }
}
